import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PackageV1 } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from '../api.service.abstract';

@Injectable({ providedIn: 'root' })
export class PackageV1Service extends ApiService<PackageV1> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'package/api/package-v1s');
    if (environment.name == 'localDev') {
      this.url = 'http://localhost:8101';
    }
  }

  public export(id: string): Observable<HttpResponse<PackageV1>> {
    return this.http.get<PackageV1>(`${this.url}/${this.endpoint}/${id}/export`, {
      observe: 'response',
    });
  }
}
